<template>
	<div :ref="fieldRef" class="text-widget-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div id="loom-container" class="text-center mt-4">
			<div v-if="loomSupported">
				<a href="#" ref="recordButton" class="loom-record-button d-inline-block btn btn-primary btn-sm">Record</a>
				<div class="loom-embed-container mt-6" v-html="value?.html"></div>
			</div>
			<div v-else-if="loomSupported !== null">
				<v-alert dense outlined type="error"> Error setting up Loom: {{ loomError }} </v-alert>
			</div>
			<AppLoader v-else />
		</div>
	</div>
</template>

<script>
import WidgetFieldMixin from './WidgetFieldMixin';
import DefaultWidgetField from './DefaultWidgetField';
import { isSupported, setup } from '@loomhq/record-sdk';
import { oembed } from '@loomhq/loom-embed';

const PUBLIC_APP_ID = process.env.VUE_APP_LOOM_PUBLIC_APP_ID;
const LOOM_INSERT_VIDEO_EVENT = 'insert-click';
const LOOM_RECORDING_START_EVENT = 'recording-start';
const LOOM_RECORDING_COMPLETE_EVENT = 'recording-complete';

export default {
	name: 'LoomInputField',
	components: {
		DefaultWidgetField,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],

	async mounted() {
		const { supported, error } = await isSupported();
		this.loomSupported = supported;
		this.loomError = error;
		if (!supported) {
			console.error(`Error setting up Loom: ${error}`);
			return;
		}
		this.$nextTick(async () => {
			const { configureButton } = await setup({ publicAppId: PUBLIC_APP_ID });
			const sdkButton = configureButton({ element: this.$refs.recordButton });
			/*
			// Does not seem to work for some reason? // https://dev.loom.com/docs/record-sdk/details/api#sdkconfig
			const sdkButtonSettings = sdkButton.store.state.settings;
			sdkButtonSettings.sdkConfig.insertButtonText = 'Gabster overrode this text';
			*/
			sdkButton.on(LOOM_RECORDING_START_EVENT, () => {
				this.$emit('field-event', { action: 'minimizeWidget' });
			});
			sdkButton.on(LOOM_RECORDING_COMPLETE_EVENT, () => {
				this.$emit('field-event', { action: 'maximizeWidget' });
			});
			sdkButton.on(LOOM_INSERT_VIDEO_EVENT, async (video) => {
				const { html } = await oembed(video.sharedUrl, { width: 400 });
				this.value = { ...video, html };
				this.$emit('on-mini-app-finished'); // should implement some setTimeout or something?
			});
		});
	},
	data: () => ({
		loomSupported: null,
		loomError: null,
	}),
};
</script>
<style scoped lang="scss">
.selected-input {
	::v-deep {
		&:focus {
			background-color: #f5f8fe;
		}
	}
}
.text-widget-field {
	::v-deep {
		input:-webkit-autofill {
			// remove chrome blue background on autocomplete input
			&,
			&:hover,
			&:focus,
			&:active {
				-webkit-box-shadow: 0 0 0 30px white inset !important;
			}
		}
	}
}
</style>
<style lang="scss">
.loom-record-button {
	text-decoration: none;
}
.loom-embed-container iframe {
	width: 100%;
}
</style>
